import { EventActionType } from './event-action-type';

export interface SetEventPlaceIdAction {
  eventKey: string;
  placeId: string;
  type: EventActionType.SetEventPlaceId;
}

export const setEventPlaceId = (
  eventKey: string,
  placeId: string,
): SetEventPlaceIdAction => ({
  eventKey,
  placeId,
  type: EventActionType.SetEventPlaceId,
});
